import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface InputState {
  selectedInputId: string | null;
}

const initialState: InputState = {
  selectedInputId: null,
};

const inputSlice = createSlice({
  name: 'input',
  initialState,
  reducers: {
    setSelectedInputId: (state, action: PayloadAction<string | null>) => {
      state.selectedInputId = action.payload;
    },
    clearInputSelection: () => initialState,
  },
});

export const { setSelectedInputId, clearInputSelection } = inputSlice.actions;

export default inputSlice.reducer;
